import { OutboundThemeProvider, theme as outboundTheme } from '@outbound-ai/ursa'
import { IChildrenNode } from 'types/propTypes'
import { Fonts } from './Fonts'
import { GlobalStyles } from './GlobalStyles'

export const theme = outboundTheme

// Define defaultHeights locally since it's not exported from ursa
// These values correspond to the theme.constants values (navbarHeight: '4rem', breadcrumbHeight: '3rem')
// Converted to pixels assuming 16px base font size
export const defaultHeights = {
  navbarHeight: 64, // 4rem * 16px = 64px
  breadcrumbHeight: 48, // 3rem * 16px = 48px
}

export const Theme = ({ children }: IChildrenNode) => {
  return (
    <OutboundThemeProvider>
      <>
        <Fonts />
        <GlobalStyles />
        {children}
      </>
    </OutboundThemeProvider>
  )
}
